import Vue from 'vue'
import metricRanges from '@/scripts/definitions/metrics-scales'

/**
 * Gets metric feedback label by level
 * @name Metric Feedback label
 * @param {object} - privacy gown
 * @param {object} - security
 * @returns {function}
 */

const metricFeedback = (value, metric) => {
  // Null/undefined values
  if (!value && value !== 0) {
    return 'none'
  }
  const levelIndex = value === 'none' ? 0 : value - 1

  return metricRanges[metric][levelIndex].label
}

Vue.filter('metricFeedback', metricFeedback)

export default metricFeedback
